import { render } from "./PencilIcon.vue?vue&type=template&id=4773520c&scoped=true"
import script from "./PencilIcon.vue?vue&type=script&lang=js"
export * from "./PencilIcon.vue?vue&type=script&lang=js"

import "./PencilIcon.vue?vue&type=style&index=0&id=4773520c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4773520c"]])

export default __exports__